export enum SceneName {
  DefaultLoadingScene = 'DefaultLoadingScene',
  BlackFadeTransition = 'BlackFadeTransition'
}
